import { useState } from "react";
import "../../Assets/Scss/Create_Company.scss";
import { Details, Personnal } from "./Components";

const CreateAdminForm = () => {
  const [Tab, setTab] = useState(2);
  const Next = () => {
    setTab(2);
  };
  const HandlePre = () => {
    setTab(1);
  };

  const [data, setData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    confirm_password: ""
  });

  return (
    <div className="Create_Wrapper">
      <h4>add i4smart admin</h4>
      <div className="Company_Grid">
        {/* <Details Click={Next} data={data} setData={setData} /> */}
        <Personnal
          Pre={HandlePre}
          setTab={setTab}
          data={data}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default CreateAdminForm;
